import ionRangeSlider from 'ion-rangeslider';
import logger from '../utils/rbmc.logger';
import facetSelection from './rbmc.facet-selection';

const priceSlider = {
    irsInstance:       null,
    irsInstanceMobile: null,
    sliderSteps:       RedBull.config.priceSliderStep || 5,
    renderLabel(data, $target) {
        let result = `<div>${RedBull.config.currencySymbol || '&euro;'}&nbsp;${data.from}</div>
                      <div>${RedBull.config.currencySymbol || '&euro;'}&nbsp;${data.to}</div>`;

        $target.html(result);
    },
    buildPriceSlider() {
        let $irsLabel       = $('#irs__label');
        let $irsLabelMobile = $('#irs__label--mobile');

        // TODO: duplicate code. Maybe different behaviour on mobile/desktop
        $('#range-slider').ionRangeSlider({
            hide_min_max: true,
            hide_from_to: true,
            keyboard:     true,
            type:         'double',
            step:         this.sliderSteps,
            prefix:       RedBull.config.currencySymbol || '&euro;',
            skin:         'round',
            onStart:      (data) => {
                this.renderLabel(data, $irsLabel);
            },
            onChange:     (data) => {
                this.renderLabel(data, $irsLabel);
            },
            onFinish:     (data) => {
                logger.log(`irs from: ${data.from} to: ${data.to}`);
                this.renderLabel(data, $irsLabel);
            },
            onUpdate:     (data) => {
                this.renderLabel(data, $irsLabel);
            }
        });

        $('#range-slider--mobile').ionRangeSlider({
            hide_min_max: true,
            hide_from_to: true,
            keyboard:     true,
            type:         'double',
            step:         this.sliderSteps,
            prefix:       RedBull.config.currencySymbol || '&euro;',
            skin:         'round',
            onStart:      (data) => {
                this.renderLabel(data, $irsLabelMobile);
            },
            onChange:     (data) => {
                this.renderLabel(data, $irsLabelMobile);
            },
            onFinish:     (data) => {
                logger.log(`irs from: ${data.from} to: ${data.to}`);
                this.renderLabel(data, $irsLabelMobile);
            },
            onUpdate:     (data) => {
                this.renderLabel(data, $irsLabelMobile);
            }
        });

        this.irsInstance       = $("#range-slider").data('ionRangeSlider');
        this.irsInstanceMobile = $("#range-slider--mobile").data('ionRangeSlider');
    },
    bindHandler() {
        $(document.body).on('click', '.js-apply-slider-selection', () => {
            this.irsInstance.update({
                'block': true
            });
            facetSelection.setPriceSliderParams(this.irsInstance.result.from, this.irsInstance.result.to);
            facetSelection.changeAndLoadURL(facetSelection.getURL(), null);
        });
        $(document.body).on('click', '.js-apply-slider-selection--mobile', () => {
            logger.log(`Got click for apply price slider on mobile view`);
            this.irsInstanceMobile.update({
                'block': true
            });
            facetSelection.setPriceSliderParams(this.irsInstanceMobile.result.from, this.irsInstanceMobile.result.to);
            facetSelection.changeAndLoadURL(facetSelection.getURL(), () => {
                $('#facet__overlay--facets').addClass('facet__overlay--visible');
                $('#facet__product-count').show();
            });
        });
    }
};

$(() => {
    if ($('#product-grid-page').length) {
        priceSlider.buildPriceSlider();
        priceSlider.bindHandler();
    }
});

export default priceSlider;
